<template>
  <div class="mx-5 mt-2">
    <div v-if="$store.state.data.workspaces?.results?.length" class="grid grid-cols-3">
      <div v-for="workspace_item in $store.state.data.workspaces.results" :key="workspace_item?.id">
        <WorkspaceItemCard :selected-workspaces="selectedWorkspaces" :handle-check-click="handleCheckClick" :workspace="workspace_item" />
      </div>
    </div>
    <div v-else class="flex items-center justify-center h-full w-full mt-16 text-center">
      <div class="flex flex-col items-center justify-center space-y-2">
        <div class="flex space-x-2 text-lg font-medium dark:text-white right-4">
          <PencilRuler class="mr-2" color="#899399" :width="24" :height="24" /> {{ $t("There are no Customer Workspaces") }}
          {{
            filterApplied || searchTerm
              ? $store.state.auth.user.user_type == "end_user"
                ? $t("matching applied query")
                : $t("for applied filter")
              : $store.state.auth.user.user_type == "end_user"
                ? $t("found")
                : $t("created")
          }}
        </div>
        <div>
          {{
            filterApplied || searchTerm
              ? $store.state.auth.user.user_type == "end_user"
                ? $t("Try again with a different query")
                : $t("Try again with a different query")
              : $store.state.auth.user.user_type == "end_user"
                ? $t("Ask for permission to be added to workspace")
                : $t("Click on the create new button above to create your first workspace")
          }}
        </div>
      </div>
    </div>

    <div v-if="$store.state.data.workspaces.next" class="mr-5">
      <button class="w-full btn cancel-btn" @click="$store.dispatch('data/getMoreWorkspaces')">
        {{ $t("Show More") }} <ChevronDown class="w-5 h-5 ml-1 mr-4" />
      </button>
    </div>

    <div v-if="availableSelectedWorkspaces.length" class="flex flex-row justify-between w-full gap-4 pt-6">
      <button
        v-if="selectedWorkspaces.size < 2"
        type="submit"
        class="w-full cancel-btn"
        @click="$router.push(`/workspace/edit/${availableSelectedWorkspaces[0]}`)">
        <Pencil
          :color="$store.state.ui.darkMode ? '#fff' : '#899399'"
          class="w-5 h-5 mr-2 transition ease-in-out duration-side-menu-transition-duration" />
        {{ $t("Edit Selected Workspace") }}
      </button>
      <button type="button" class="w-full delete-btn" @click="$emitter.emit(ALL_EMITTERS.DELETE_WORKSPACES, [...selectedWorkspaces])">
        <Trash2 color="red" class="w-5 h-5 mr-2 transition ease-in-out dark:text-white duration-side-menu-transition-duration" />
        {{ $t("Delete Selected Workspace(s)") }}
      </button>
    </div>
  </div>
</template>

<script>
import WorkspaceItemCard from "./WorkspaceItemCard.vue"
import { ChevronDown, Trash2, Pencil, PencilRuler } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { WorkspaceItemCard, PencilRuler, Pencil, Trash2, ChevronDown },
  props: {
    selectedWorkspaces: {
      type: Set,
      required: true
    },
    handleCheckClick: {
      type: Function,
      required: true
    },
    filterApplied: {
      type: Boolean,
      default: false
    },
    searchTerm: {
      type: String,
      default: ""
    }
  },
  emits: [],
  data() {
    return {
      ALL_EMITTERS
    }
  },
  computed: {
    availableSelectedWorkspaces() {
      return Array.from(this.selectedWorkspaces).filter((selected_workspace) =>
        this.$store.state.data.workspaces?.results?.find((w) => w.short_id == selected_workspace)
      )
    }
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
